import React from "react";
import { Fonts } from "../../constant/fonts";

export default function Head(props) {
    const { title, font, analytics } = props.variables;

    React.useEffect(() => {
        title && (document.title = title);
    }, [title]);

    React.useEffect(() => {
        if (!Fonts[font]) {
            return;
        }

        const id = "AppFont";
        const appFontElement = document.head.querySelector(id) || document.createElement("link");
        if (!font) {
            appFontElement.parentElement && appFontElement.parentElement.removeChild(appFontElement);
        } else {
            appFontElement.setAttribute("id", id);
            appFontElement.setAttribute("href", Fonts[font].url);
            if (!appFontElement.parentElement) {
                appFontElement.setAttribute("rel", "stylesheet");
                document.head.appendChild(appFontElement);
            }
        }
    }, [font]);

    React.useEffect(() => {
        for (const dom of document.head.querySelectorAll("*[pb-analytics]")) {
            dom.parentElement && dom.parentElement.removeChild(dom);
        }

        if (analytics) {
            const domAnalytics = document.createElement("div");
            domAnalytics.innerHTML = analytics;

            for (const child of domAnalytics.children) {
                child.setAttribute("pb-analytics", "");
                document.head.appendChild(child);
            }
        }
    }, [analytics]);

    return null;
}
